import script from "./PaymentView.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentView.vue?vue&type=script&setup=true&lang=js"

import "./PaymentView.vue?vue&type=style&index=0&id=129f4c74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-129f4c74"]])

export default __exports__